import capitalize from 'lodash/capitalize';
import React from 'react';
import { getDateRangeForAPeriodFilter } from '../ReportFilters.utils';

/*
Type for elements accessed via QueryParameters.
The type is maintained only for the use of utility file here
 */

export const getSummaryText = (options, selectedValue) => {
  if (typeof selectedValue === 'string') {
    var _selectedOption$label;
    const selectedOption = options.find(option => option.value === selectedValue);
    return (_selectedOption$label = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _selectedOption$label !== void 0 ? _selectedOption$label : '';
  } else if (Array.isArray(selectedValue)) {
    const selectedOptions = options.filter(option => {
      var _option$value;
      return selectedValue.includes((_option$value = option.value) !== null && _option$value !== void 0 ? _option$value : '');
    });
    return selectedOptions.map(option => option.label).join(', ');
  } else {
    return null;
  }
};
export const generateSummaryContent = _ref => {
  let {
    title,
    text
  } = _ref;
  const prefix = title ? "".concat(title, ": ") : '';
  return text ? /*#__PURE__*/React.createElement(React.Fragment, null, prefix, /*#__PURE__*/React.createElement("b", null, text)) : null;
};
export const getTextSummaryItem = text => {
  if (text) {
    const value = Array.isArray(text) ? text.join() : text;
    if (value.length > 0) {
      return generateSummaryContent({
        text: "\"".concat(value, "\"")
      });
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export const getDateRangeSummaryItem = function getDateRangeSummaryItem(period, startDate, endDate) {
  let dateType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  /*
    This function helps to take the respective array item, in case the param
    is passed as an array. It'll happen when the user directly params in the URL
   */
  const getValueFromQueryParam = date => {
    if (Array.isArray(date) && date.length > 0) {
      return date[0].toString();
    } else {
      var _date$toString;
      return (_date$toString = date === null || date === void 0 ? void 0 : date.toString()) !== null && _date$toString !== void 0 ? _date$toString : '';
    }
  };
  if (period) {
    let startDateText = getValueFromQueryParam(startDate);
    let endDateText = getValueFromQueryParam(endDate);
    if (period !== 'custom') {
      const actualRange = getDateRangeForAPeriodFilter(period);
      startDateText = actualRange.startDate;
      endDateText = actualRange.endDate;
    }
    const dateTypeText = dateType ? "".concat(capitalize(getValueFromQueryParam(dateType)), " dates from ") : '';
    const text = "".concat(dateTypeText).concat(startDateText, " to ").concat(endDateText);
    return generateSummaryContent({
      title: 'Date range',
      text
    });
  } else {
    return null;
  }
};
export const summarise = items => {
  const filters = items.filter(item => item !== null);
  if (filters.length > 0) {
    return /*#__PURE__*/React.createElement("div", null, "You searched for", ' ', filters.reduce((prev, cur) => /*#__PURE__*/React.createElement(React.Fragment, null, prev, ", ", cur)));
  } else {
    return null;
  }
};